import React, { useMemo } from "react";
import Brands from "../brands/brands";
import Products from "../products/products";
import Searches from "../searches/searches";
import {
  StyledFirstSectionWrapper,
  StyledGridContainer,
  StyledGridRow,
  StyledMiddleSection,
  StyledProductSectionWrapper,
} from "./search-results.styles";
import { useDataContext } from "client/context/DataContext";

const SearchResults = ({
  isThreeColumn,
  brand,
  isSFLVeryIEHeaderEnabled,
}: {
  isThreeColumn: boolean;
  brand: string;
  isSFLVeryIEHeaderEnabled: boolean;
}): JSX.Element => {
  const { isRecommendations } = useDataContext();

  const cnstrcData = useMemo(
    () => (!isRecommendations ? { ["data-cnstrc-autosuggest"]: true } : {}),
    [isRecommendations],
  );

  return (
    <StyledGridContainer data-testid="search-results-wrapper" {...cnstrcData}>
      <StyledGridRow>
        <StyledFirstSectionWrapper
          xxs={12}
          m={12}
          l={3}
          className="grid-item"
          data-testid="search-results-first-section"
        >
          <Brands />
          <Searches />
        </StyledFirstSectionWrapper>

        <StyledMiddleSection xxs={1} className="grid-item" />

        <StyledProductSectionWrapper
          xxs={12}
          m={12}
          l={isThreeColumn ? 12 : 8}
          className="grid-item"
          data-testid="search-results-second-section"
        >
          <Products
            isThreeColumn={isThreeColumn}
            brand={brand}
            isSFLVeryIEHeaderEnabled={isSFLVeryIEHeaderEnabled}
          />
        </StyledProductSectionWrapper>
      </StyledGridRow>
    </StyledGridContainer>
  );
};

export default SearchResults;
